import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ShieldCheck, LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";

const links = [
  { to: "/", label: "Ana Sayfa", id: "anasayfa" },
  { to: "/hosting", label: "Hosting", id: "hosting" },
  { to: "/sunucular", label: "Sunucular", id: "sunucular" },
  { to: "/alan-adi", label: "Alan Adı", id: "alan-adi" },
  { to: "/guvenlik", label: "Güvenlik", id: "guvenlik" },
  { to: "/fiyatlandirma", label: "Fiyatlandırma", id: "fiyatlandirma" },
  { to: "/iletisim", label: "İletişim", id: "iletisim" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#0A0B10]/80 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 lg:px-8 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group">
          <div className="relative">
            <div className="absolute inset-0 bg-blue-500/40 blur-lg group-hover:bg-blue-500/60 transition-all" />
            <div className="relative w-9 h-9 rounded-xl bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center">
              <ShieldCheck size={20} strokeWidth={2.2} className="text-white" />
            </div>
          </div>
          <span className="font-heading font-bold text-xl tracking-tight">
            DR <span className="text-blue-500">SOFT</span>
          </span>
        </Link>

        <div className="hidden lg:flex items-center gap-1">
          {links.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              data-testid={`nav-link-${link.id}`}
              className={({ isActive }) =>
                `px-3 py-2 text-sm font-medium rounded-full transition-all ${
                  isActive ? "text-white bg-white/5" : "text-zinc-400 hover:text-white hover:bg-white/5"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </div>

        <div className="hidden lg:flex items-center gap-2">
          <Link to="/giris" data-testid="nav-cta-login">
            <Button variant="ghost" className="text-zinc-300 hover:text-white hover:bg-white/5 rounded-full gap-2">
              <LogIn size={15} /> Giriş Yap
            </Button>
          </Link>
          <Link to="/fiyatlandirma" data-testid="nav-cta-getstarted">
            <Button className="btn-shine rounded-full bg-blue-600 hover:bg-blue-500 text-white shadow-[0_0_20px_rgba(0,122,255,0.25)] hover:shadow-[0_0_30px_rgba(0,122,255,0.5)] transition-all">
              Hemen Başla
            </Button>
          </Link>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden p-2 text-white rounded-lg hover:bg-white/5"
          onClick={() => setOpen(!open)}
          aria-label="Menü"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      <div className={`lg:hidden overflow-hidden transition-all duration-300 ${open ? "max-h-[600px] border-t border-white/5" : "max-h-0"}`}>
        <div className="px-6 py-4 flex flex-col gap-1 bg-[#0A0B10]/95 backdrop-blur-xl">
          {links.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              data-testid={`mobile-nav-link-${link.id}`}
              className={({ isActive }) =>
                `px-4 py-3 rounded-xl text-sm font-medium ${
                  isActive ? "bg-white/5 text-white" : "text-zinc-400 hover:text-white hover:bg-white/5"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
          <Link to="/giris" data-testid="mobile-nav-login" className="mt-2 px-4 py-3 rounded-xl text-sm font-medium text-center border border-white/10 text-white hover:bg-white/5">
            Giriş Yap
          </Link>
          <Link to="/fiyatlandirma" data-testid="mobile-nav-cta" className="mt-1 px-4 py-3 rounded-xl text-sm font-medium text-center bg-blue-600 hover:bg-blue-500 text-white">
            Hemen Başla
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
